import ManualBreadcrumbItem from './ManualBreadcrumbItem';

export default ManualBreadcrumbItem;
